'use strict';

import $ from 'jquery';

// Av ngn magisk anledning måste denna importeras, även om den inte anv av denna kod. Har kanske att göra med att det är jQuery och inte 'äkta' modulariserat?
// eslint-disable-next-line no-unused-vars
import dt from 'datatables.net';


let initiera = function (dataTableData)
{
	return $('#_ss-tabellen_kropp').DataTable({

		// Todo: TMP!!!
		data: dataTableData,

		ordering: false,
		/*order: [[0, 'asc']],*/

		dom: 't',	/* Se https://datatables.net/reference/option/dom */
		searching: true,
		/* Sätt den initiala filtreringen: */
		/* Kan även göras med API, så här: tabellen.column(5).search('true').draw(); och '' invaliderar filtret. */
		searchCols: [
			null
			, null
			, null
			, null
			, null
			, { search: 'true' }	// Initialt visas endast använda konton.
		],

		language: {
			loadingRecords: 'Laddar...',
			processing: 'Bearbetar...',
			emptyTable: 'Inga konton att visa',
			zeroRecords: 'Inga konton matchar ditt filter &nbsp; :('	/* Avser endast filtreringsresultatet! */
		},
		paging: false,
		info: false,
		processing: false,
		autoWidth: false,
		deferRender: true,

		/* Anv inte, bl.a. p.g.a... se kommentar i Kontoutdrag.cshtml */
		stateSave: false,
		/* Kan invalideras med tabellen.state.clear(); */

		/*stripeClasses: [ 'ss-udda', 'ss-jamn' ],*/

		responsive: false,	/* Extension som vi inte anv f.n. */

		columnDefs: [
			{ name: 'kontonr', type: 'html', targets: 0, className: 'nw' }		/* type behövs för sortering (icke numerisk (och även med ev html-taggar bortskalade, men det klarar DataTables annars utan att type sätts)). */
			, { name: 'benamning', targets: 1, className: 'nw' }
			, { name: 'typ', targets: 2, className: 'nw' }
			, { name: 'reskFort', targets: 3, className: 'nw' }
			, { name: 'saldo', targets: 4, className: 'nw hj', searchable: false }
			// ----- Visas inte:
			, { name: 'anv', targets: 5, visible: false }
		],

		createdRow(row, data, index)
		{
			let anvantEllerHarSaldo = data[5];

			/* Oanvänt konto (*och* saknar saldo): */
			if (anvantEllerHarSaldo === false)
			{

				/* Styla alla cellerna: */
				$('td', row).addClass('fsv str-bg');
			}
		},
	});
};

let ssoKontoplanDatatable = { 
	// Methods:
	initiera,
};

export { ssoKontoplanDatatable };
